export class AuthToketRequest{
    remoteEyeTokenLink: string | undefined;
}